import { useLocation } from "react-use";

export function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}
